import { getTenantIDBasedOnURL } from 'global/tenant-config';
import { useMutation, useQueryClient } from 'react-query';
import { useModal } from 'store/modals';
import { LAUNDRY_BOOKINGS } from '../bookings';
import { NON_BOOKABLE_SLOTS } from '../non-bookable-slots';
import { BOOKING_HISTORY } from '../booking-history';
import { deleteBookingAPI } from './api';

export function useDeleteBooking({ onSuccess } = {}) {
  const queryClient = useQueryClient();
  const tenantId = getTenantIDBasedOnURL();
  const { openModal } = useModal();

  const { mutateAsync, isLoading, isSuccess, isError, error } = useMutation(
    (bookingId) => deleteBookingAPI(bookingId),
    {
      onSuccess: () => {
        openModal({
          modalType: 'NotificationModal',
          modalProps: {
            type: 'success',
            description: 'deleteBookingSuccess',
          },
        });
        queryClient.invalidateQueries([LAUNDRY_BOOKINGS, tenantId]);
        queryClient.invalidateQueries([NON_BOOKABLE_SLOTS, tenantId]);
        queryClient.invalidateQueries([BOOKING_HISTORY, tenantId]);
        if (onSuccess) {
          onSuccess();
        }
      },
      onError: () => {
        openModal({
          modalType: 'NotificationModal',
          modalProps: {
            type: 'error',
            description: 'deleteBookingFail',
          },
        });
      },
    },
  );

  return {
    deleteBooking: mutateAsync,
    isSuccess,
    isLoading,
    isError,
    error: error && error.message,
  };
}

